import i18n from "i18next";
import { initReactI18next } from 'react-i18next';
import plTranslation from './locales/pl/translation.json'
import enTranslation from './locales/en/translation.json'
import deTranslation from './locales/de/translation.json'

import plRecovery from './locales/pl/checkoutRecovery.json'
import enRecovery from './locales/en/checkoutRecovery.json'
import deRecovery from './locales/de/checkoutRecovery.json'

i18n.use(initReactI18next).init({
    resources: {
        pl: {
            translation: {
                ...plTranslation,
                recovery: plRecovery,
            },
        },
        en: {
            translation: {
                ...enTranslation,
                recovery: enRecovery,
            },
        },
        de: {
            translation: {
                ...deTranslation,
                recovery: deRecovery,
            },
        },
    },
    lng: 'pl',
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false,
    },
});

export default i18n;
